import { createApp } from "vue";
// import App from "./App.vue";
import App from "./App3Forms.vue";
import PrimeVue from 'primevue/config';
import 'primevue/resources/themes/lara-light-green/theme.css';
import '/node_modules/primeflex/primeflex.css';
// import 'primevue/resources/themes/aura-light-green/theme.css'
// import VueCookies from 'vue3-cookies'

const app = createApp(App);
app.use(PrimeVue);
// app.use(VueCookies, {
//     expireTimes: "30d",
//     path: "/",
//     domain: "",
//     secure: true,
//     sameSite: "None"
// });

// app.mount("#app");
// app.mount("#app_blog_form");
app.mount("#forms3");
